<template>
  <el-row :gutter="40" class="panel-group" v-loading="loading">
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('purchases')">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">店铺总营业额</div>
          <span style="font-size:20px;">{{detail.business_total_price ? (detail.business_total_price - 0).toFixed(2) : 0.00}}</span>
        </div>
        <div style="position:absolute;right:6px;bottom:4px;">
          <download-excel
        :fields="json_fields"
        :fetch='function () {
            return postOrder(1);
          }'  
        :before-generate="startPost"
        :before-finish="endPost"
        
        :header="
          detail.business_total_price
            ? '店铺总营业额:' + (detail.business_total_price - 0).toFixed(2)
            : '店铺总营业额:' + 0.0
        "
        type="xls"
        worksheet="店铺总营业额"
        name="店铺总营业额.xls"
      >
        <el-link type="success"> 导出订单信息</el-link> 
      </download-excel></div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('messages')">
        <div class="card-panel-icon-wrapper icon-message">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">已使用优惠券金额</div>
          <span style="font-size:20px;">{{detail.business_discount_price ? (detail.business_discount_price - 0).toFixed(2) : 0.00}}</span>
        </div>
        <div style="position:absolute;right:6px;bottom:4px;">     <download-excel
        :fields="json_fields"
        :fetch='function () {
            return postOrder(4);
          }
        '
        :before-generate="startPost"
        :before-finish="endPost"
        
        :header="
          detail.business_discount_price
            ? '已使用优惠券金额:' +
              (detail.business_discount_price - 0).toFixed(2)
            : '已使用优惠券金额:' + 0.0
        "
        type="xls"
        worksheet="已使用优惠券金额"
        name="已使用优惠券金额.xls"
      >
        <el-link type="success"> 导出订单信息 </el-link>
      </download-excel></div>
      </div>
    </el-col>
    
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('messages')">
        <div class="card-panel-icon-wrapper icon-nine">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">已结算金额</div>
          <span style="font-size:20px;">{{(detail.settled_amount - 0).toFixed(2)}}</span>
        </div>
        <div style="position:absolute;right:6px;bottom:4px;"><download-excel
        :fields="json_fields"
        :fetch='function () {
            return postOrder(2);
          }'
        
        :before-generate="startPost"
        :before-finish="endPost"
        
        :header="
          detail.business_total_price
            ? '已结算金额:' + (detail.business_total_price - 0).toFixed(2)
            : '已结算金额:' + 0.0
        "
        type="xls"
        worksheet="已结算金额"
        name="已结算金额.xls"
      >
        <el-link type="success"> 导出订单信息 </el-link>
      </download-excel></div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('messages')">
        <div class="card-panel-icon-wrapper icon-eight">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">待结算金额(包括拼团中)</div>
          <span style="font-size:20px;">{{(detail.unsettled_amount - 0).toFixed(2)}}</span>
        </div>
        <div style="position:absolute;right:6px;bottom:4px;">
          <download-excel
        :fields="json_fields"
        :fetch='function () {
            return postOrder(3);
          }
        '
        :before-generate="startPost"
        :before-finish="endPost"
        
        :header="
          detail.unsettled_amount
            ? '待结算金额(包括拼团中):' +
              (detail.unsettled_amount - 0).toFixed(2)
            : '待结算金额(包括拼团中):' + 0.0
        "
        type="xls"
        worksheet="待结算金额(包括拼团中)"
        name="待结算金额(包括拼团中).xls"
      >
        <el-link type="success"> 导出订单信息 </el-link>
      </download-excel>
        </div>
      </div>
    </el-col>
    
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('messages')">
        <div class="card-panel-icon-wrapper icon-message">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">总产生佣金</div>
          <span style="font-size:20px;">{{(detail.commission_total - 0).toFixed(2)}}</span>
        </div>
        <div style="position:absolute;right:6px;bottom:4px;">     <download-excel
        :fields="w_json_fields"
        :fetch='function () {
            return postShopWithdraw(0);
          }
        '
        :before-generate="startPost"
        :before-finish="endPost"
        
        :header="
          detail.commission_total
            ? '总产生佣金:' +
              (detail.commission_total - 0).toFixed(2)
            : '总产生佣金:' + 0.0
        "
        type="xls"
        worksheet="总产生佣金"
        name="总产生佣金.xls"
      >
        <el-link type="success"> 导出提现记录 </el-link>
      </download-excel></div>
      </div>
    </el-col>

    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('purchases')">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">已提现</div>
          <span style="font-size:20px;">{{(detail.withdrawn_total - 0).toFixed(2)}}</span>
        </div>
        <div style="position:absolute;right:6px;bottom:4px;">     <download-excel
        :fields="w_json_fields"
        :fetch='function () {
            return postShopWithdraw(2);
          }
        '
        :before-generate="startPost"
        :before-finish="endPost"
        
        :header="
          detail.withdrawn_total
            ? '已提现:' +
              (detail.withdrawn_total - 0).toFixed(2)
            : '已提现:' + 0.0
        "
        type="xls"
        worksheet="已提现"
        name="已提现.xls"
      >
        <el-link type="success"> 导出提现记录 </el-link>
      </download-excel></div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('newVisitis')">
        <div class="card-panel-icon-wrapper icon-seven">
          <svg-icon icon-class="money" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">待提现</div>
          <span style="font-size:20px;">{{(detail.wait_withdrawn_total - 0).toFixed(2)}}</span>
        </div>
        <div style="position:absolute;right:6px;bottom:4px;">     <download-excel
        :fields="w_json_fields"
        :fetch='function () {
            return postShopWithdraw(1);
          }
        '
        :before-generate="startPost"
        :before-finish="endPost"
        
        :header="
          detail.wait_withdrawn_total
            ? '待提现:' +
              (detail.wait_withdrawn_total - 0).toFixed(2)
            : '待提现:' + 0.0
        "
        type="xls"
        worksheet="待提现"
        name="待提现.xls"
      >
        <el-link type="success"> 导出提现记录 </el-link>
      </download-excel></div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import request from "@/utils/request";
import Vue from "vue";
import downloadExcel from "vue-json-excel";
export default {
  components: { downloadExcel },
  data() {
    return {
       loading: false,
      json_fields: {
        "订单号 ": {
          field: "order_no",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "所在供应商 ": "shop_name",
        "昵称 ": "user.nickname",
        "联系电话 ": "phone",
        "商品名称 ": "product.title",
        "价格 ": {
          field: "pay_price",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "优惠券金额 ": {
          field: "discount_price",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "酒店 ": "shop_name",
        "时间 ": {
          field: "created_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        },
        //用户提现
       w_json_fields: {
        "店铺名称 ": "shop.name",
        "提现金额 ": {
          field: "money",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "实际到账 ": {
          field: "actual_receipt",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "扣除佣金 ": {
          field: "commission",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "提现后金额 ": {
          field: "after_balance",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "状态 ": {
          field: "status",
          //自定义回调函数
          callback: (value) => {
            if(value==1){
return "待审核";
            }else if(value==2){
return "已审核";
            }else if(value==3){
return "拒绝";
            }
            
          },
        },
        "提交时间 ": {
          field: "created_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "处理时间 ": {
          field: "updated_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
      
      },
    }},
  props: {
    detail: {
      type: Object,
      default: {}
    }
  },
  methods: {
    handleSetLineChartData(type) {
      return;
      this.$emit("handleSetLineChartData", type);
    },
    startPost() {
      this.loading = true;
    },
    endPost() {
      this.loading = false;
    },
    //导出订单
    postOrder(type) {
      if(type==5){
        this.json_fields={
           "分佣人昵称 ": "order_reward_log.reward_user.nickname",
        "订单号 ": {
          field: "order_no",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "所在供应商 ": "shop_name",
        "昵称 ": "user.nickname",
        "联系电话 ": "phone",
        "商品名称 ": "product.title",
        "价格 ": {
          field: "pay_price",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "优惠券金额 ": {
          field: "discount_price",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "酒店 ": "shop_name",
        "时间 ": {
          field: "created_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "分佣金额 ": {
          field: "order_reward_log.reward_price",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
      }
      }else{
          this.json_fields={
        "订单号 ": {
          field: "order_no",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "所在供应商 ": "shop_name",
        "昵称 ": "user.nickname",
        "联系电话 ": "phone",
        "商品名称 ": "product.title",
        "价格 ": {
          field: "pay_price",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "优惠券金额 ": {
          field: "discount_price",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        "酒店 ": "shop_name",
        "时间 ": {
          field: "created_at",
          //自定义回调函数
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
      }
      }
      this.listLoading = true;
      return request({
        url: "/api/backend/finance/shop/postOrder",
        method: "get",
        params: {
          start_datetime: this.detail.listQuery.start_datetime,
          end_datetime: this.detail.listQuery.end_datetime,
          type: type,
        },
      })
        .then((result) => {
          var json_data = result.data;
          json_data.forEach(function (item, index) {
            json_data[index].order_no = json_data[index].order_no + "";
            Vue.set(
              json_data[index],
              "shop_name",
              item.input_shop_id != 0 ? item.shop.name : "平台自营"
            ); //正确姿势
          });
          console.log(json_data);
          
          return json_data;
          
        })
        .catch((err) => {
          console.log(err);
        }).finally(()=>{
this.loading = false;
        });
    },
    postShopWithdraw(type){
      this.listLoading = true;
      return request({
        url: "/api/backend/shop/postShopWithdraw",
        method: "get",
        params: {
          start_datetime: this.detail.listQuery.start_datetime,
          end_datetime: this.detail.listQuery.end_datetime,
          type: type,
        },
      })
        .then((result) => {
          var json_data = result.data;

          console.log(json_data);
          
          return json_data;
          
        })
        .catch((err) => {
          console.log(err);
        }).finally(()=>{
this.loading = false;
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3;
      }

      .icon-five {
        background: #dfee0a;
      }

      .icon-six {
        background: #bf34b3;
      }
      .icon-seven {
        background: #ff00ff;
      }
      .icon-eight {
        background: #0000cd;
      }
      .icon-nine {
        background: #00ff00;
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3;
    }

    .icon-five {
      color: #dfee0a;
    }

    .icon-six {
      color: #bf34b3;
    }
    .icon-seven {
      color: #ff00ff;
    }
    .icon-eight {
      color: #0000cd;
    }
    .icon-nine {
      color: #00ff00;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: left;
      font-weight: bold;
      margin: 26px;
      margin-left: 10px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width: 550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
